import { assertLeaderMayAct, runRound } from '../round.ts';
import { type CommandHandler, none } from './types.ts';

/**
 * The leader does nothing this round. If the leader is charging, the charge
 * fires. The only round-ending command an asleep or stunned leader may send.
 */
export type WaitCommand = {
  readonly type: 'wait';
};

export const wait: CommandHandler<WaitCommand> = (ctx, state) => {
  assertLeaderMayAct(state, 'wait');
  return runRound(ctx, state, none, 'wait');
};
